import { i18n } from '@/local/index';

// Find vouchers that meet the threshold and offer the maximum discount
export function findOptimalPromotion(arr, target) {
  let max = {
    threshold: 0
  };
  arr.forEach(item => {
    if (item.threshold <= target && item.threshold > max.threshold) max = item;
  });
  return max.threshold > 0 ? max : null;
}

export function handleRequestParams(
  promotionsIds,
  withRedeemedCouponStatus = false
) {
  let requestData = promotionsIds
    .map(
      promotionId =>
        `encryptedPromotionIdList=${encodeURIComponent(promotionId)}`
    )
    .join('&');
  requestData += `&withRedeemedCouponStatus=${encodeURIComponent(
    withRedeemedCouponStatus
  )}`;
  return requestData;
}
// Popup Text
export const popUpTextList = {
  importFee: {
    title: i18n.global.t('modules.checkout.CSF_DESCRIPTION'),
    content: i18n.global.t(
      'modules.checkout.AMAZON_WILL_ESTIMATE_IMPORT_FEES_FOR_ORDER'
    )
  },
  shippingFee: {
    title: i18n.global.t('modules.checkout.SHIPPING_FEE_DESCRIPTION'),
    content: i18n.global.t(
      'modules.checkout.LOGISTICS_AND_DELIVERY_COSTS_INCURRED_ON_ORDER'
    )
  }
};
export const popUpType = {
  CSF_DESC: 'csfDesc',
  SHIPPING_FEE_DESC: 'shippingFeeDesc',
  ORDER_AUTH_DESC: 'orderAuthDesc'
};
